export const TIME_FORMAT_REGEX = /^([0-1]\d|2[0-3]):([0-5]\d)$/

export const HOURS_FORMAT_PATTERN = /^\d{2}:\d{2}$/
export const HOURS_VALID_TIME_REGEX = /^(?:[01]?\d|2[0-3]):[0-5]\d$|^24:00$/
